import { combineReducers } from 'redux'

import { RequestLocationStatus } from 'src/services/frontend_statuses'

import {
  FETCH_EVENT_COMMENTS_SUCCESS,
  FETCH_EVENT_COMMENTS_ERROR
} from 'src/actions'

import {
  GEOLOCATION_PERMISSION_CHANGED,
  REQUEST_SHARE_LOCATION_IN_CHAT,
  SHARE_LOCATION_RETRIEVED,
  SHARE_LOCATION_DENIED
} from 'src/actions/chat'

const commentsLoadingStatus = (state = 'not_loaded', action) => {
  switch (action.type) {
    case FETCH_EVENT_COMMENTS_SUCCESS:
      if (!action.apiPayload.hasMoreEntities) {
        return 'loaded'
      } else {
        return state
      }
    case FETCH_EVENT_COMMENTS_ERROR:
      return 'error'
    default:
      return state
  }
}

const requestLocationStatus = (state = RequestLocationStatus.NOT_LOADING, action) => {
  switch (action.type) {
    case REQUEST_SHARE_LOCATION_IN_CHAT:
      return RequestLocationStatus.REQUESTED
    case GEOLOCATION_PERMISSION_CHANGED:
      if (state === RequestLocationStatus.REQUESTED && action.permission_state === RequestLocationStatus.GRANTED) {
        return RequestLocationStatus.ACCEPTED
      } else {
        return state
      }
    case SHARE_LOCATION_RETRIEVED:
      return RequestLocationStatus.LOCATION_RETRIEVED
    case SHARE_LOCATION_DENIED:
      return RequestLocationStatus.DENIED
    default:
      return state
  }
}

export default combineReducers({
  commentsLoadingStatus,
  requestLocationStatus
})



// WEBPACK FOOTER //
// ./src/reducers/frontend/chat.js